import { auditReportsExecuteGipAltReport } from '@mi-front/api-v2';
import { ViewLoader } from '@ui/utils';
import { useIntl } from 'react-intl';
import { useClient } from '../../../../../../../../core/auth/profile/hooks/useClient';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import { useStationsWithAudit } from '../../../../../../hooks/useStationsWithAudit';
import { GipReportForm } from '../../gip-report/config/form/GipReportForm';
import { useGipQueryParamsTransform } from '../../gip-report/config/form/hooks/useGipQueryParamsTransform';
import { useGipReportDefaultValues } from '../../gip-report/config/form/hooks/useGipReportDefaultValues';
import {
  gipReportDateRangeExceededMessage,
  gipReportFromMustBeBeforeToMessage,
} from '../../gip-report/config/gip-report-validation-messages';
import {
  assertGipReportDateRange,
  GIP_REPORT_MAX_DATE_RANGE_DAYS,
} from '../../gip-report/config/utils/assert-gip-report-date-range';
import { mapValuesToGipReportDataDto } from '../../gip-report/config/utils/gip-report-values-to-data-dto';
import { useGipValuesFromReportId } from '../../gip-report/preview/hooks/useGipValuesFromState';
import { GipAlternativeReportFormActions } from './components/ReportActions';
import { GipAltReportResultView } from './components/result/GipAltReportResultView';
import { GipAlternativeReportType } from './types';

type Props = Record<string, never>;

export function GipAltReportPreviewView(_props: Props) {
  const stations = useStationsWithAudit();
  const client = useClient();
  const intl = useIntl();

  const defaultValues = useGipReportDefaultValues();
  const { values: passedValues, isLoading } = useGipValuesFromReportId();

  const paramsTransform = useGipQueryParamsTransform();

  if (isLoading) {
    return <ViewLoader />;
  }

  return (
    <ReportView<GipAlternativeReportType>
      download={{
        local: false,
        filename: 'gip-alternative-report',
      }}
      runOnLoad={!!passedValues}
      defaultValues={passedValues ?? defaultValues}
      queryParamsTransform={paramsTransform}
      reportFn={async (values, format) => {
        assertGipReportDateRange(
          values,
          GIP_REPORT_MAX_DATE_RANGE_DAYS,
          intl.formatMessage(gipReportDateRangeExceededMessage, {
            maxDays: GIP_REPORT_MAX_DATE_RANGE_DAYS,
          }),
          intl.formatMessage(gipReportFromMustBeBeforeToMessage),
        );

        const config = mapValuesToGipReportDataDto(client.id, values, stations);

        return auditReportsExecuteGipAltReport(
          config,
          format ? { format } : undefined,
          format ? { responseType: 'arraybuffer' as const } : undefined,
        ) as unknown as GipAlternativeReportType['Result'];
      }}
      Form={GipReportForm}
      FormActions={GipAlternativeReportFormActions}
      Result={GipAltReportResultView}
    />
  );
}
